import { useCheckTeamRecordStatus } from './hooks/useCheckTeamRecordStatus'
import { useFetchTeam } from './hooks/useFetchTeam'
import { updateTeam } from './team.api'

class TeamService {
  team = {
    useCheckRecordStatus: useCheckTeamRecordStatus,
    update: updateTeam,
    fetchOne: useFetchTeam
  }
}

export const teamService = new TeamService()
